import React from 'react';

import ReactDOM from 'react-dom';

import { ErrorPage } from '@qality/common-pages';
import { ErrorReportingService, FlagService } from '@qality/common-service';

export default {
  handleError(
    error: Error,
    message: string,
    title = 'Something apparently went wrong. Your error message is:'
  ): void {
    // eslint-disable-next-line no-console
    console.error(error);

    FlagService.createFlag(title, message, 'error');
  },

  handleCriticalError(error: Error, message: string): void {
    const errorDetails = ErrorReportingService.getDetails(error, message);

    let containerName = 'com_soldevelo_apps_test-management-premium_container';
    if (plugin.isFree) {
      containerName = 'com_soldevelo_apps_test-management_container';
    }

    const container = document.getElementById(containerName);

    if (container) {
      ReactDOM.render(
        <ErrorPage
          error={error}
          errorDetails={errorDetails}
          message={message}
        />,
        container
      );
    }
  },
};
